import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { ErrorBoundary } from '@/components/ErrorBoundary'
import { ThemeProvider } from '@/components/theme-provider'
import { Toaster } from '@/components/ui/sonner'
import { AppSelector } from '@/components/AppSelector'
import { mykoobAdminRouteBranch } from '@/apps/mykoob-admin/routes'
import { ekoolTeacherRouteBranch } from '@/apps/ekool-teacher/routes'

function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider defaultTheme="system" storageKey="ekool-ui-theme">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<AppSelector />} />
            {mykoobAdminRouteBranch}
            {ekoolTeacherRouteBranch}
          </Routes>
          <Toaster />
        </BrowserRouter>
      </ThemeProvider>
    </ErrorBoundary>
  )
}

export default App
